export async function triggerUrlDownload(url: string, filename?: string) {
  void filename;
  window.open(url, "_blank", "noopener,noreferrer");
}
